export default __webpack_public_path__ + "static/media/search-icon.054d49e3.svg";